import {translation} from "@2d-front-monorepo/core";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import IAttachments from "../interfaces/IAttachments";
import EntityDocumentation from "./EntityDocumentation";

export interface AttachmentsComponentProps {
	entity: IAttachments;
	linkPrefix: string;
	className: string;
}

export default function AttachmentsComponent({entity, linkPrefix, className}: AttachmentsComponentProps): JSX.Element {
	if (entity.attachments.length === 0) {
		return <></>;
	}

	return <dl className={"title-desc " + className}>
		<dt>{translation(PermitTranslations.documentation)}</dt>
		<dd><EntityDocumentation linkPrefix={linkPrefix} entity={entity}/></dd>
	</dl>;
}
